<template>
  <section class="grid grid-cols-1 md:grid-cols-6 gap-6 w-full">
    <!-- Main Content -->
    <div class="md:col-span-4">
      <MainHeader />
    </div>

    <!-- Sidebar -->
    <div class="md:col-span-2">
      <SideHeader />
    </div>
  </section>
  <section class="my-6">
    <h3 class="text-2xl font-semibold mb-4">Top Stories</h3>

    <div class="text-gray-500 p-6 rounded-lg text-center">There are no stories to display.</div>
  </section>
  <FooterSection class="mt-8" />
</template>

<script>
import MainHeader from '@/components/partials/home/MainHeader.vue';
import SideHeader from '@/components/partials/home/SideHeader.vue';
import FooterSection from '@/components/partials/home/FooterSection.vue';

export default {
  components: {
    MainHeader,
    SideHeader,
    FooterSection
  }
};
</script>
